const SDG_ICON_URLS = import.meta.glob<string>('../assets/sdgs/*.svg', {
	eager: true,
	query: '?url',
	import: 'default',
});

export const SDG_GOALS = Array.from({ length: 17 }, (_, index) => index + 1);

/** The UN goal's icon, number and pictogram only, so it reads the same in every language; undefined outside 1–17. */
export function sdgIconUrl(goal: number): string | undefined {
	return SDG_ICON_URLS[`../assets/sdgs/${goal}.svg`];
}
